import type { IRouteContext } from '@shared/types/route-context'

export const middlewarePipeline = ({
  context,
  middleware,
  index,
}: {
  context: IRouteContext
  middleware: Array<({ to, from, next }: IRouteContext) => void>
  index: number
}) => {
  const nextMiddleware = middleware[index]

  if (!nextMiddleware) {
    return context.next
  }

  return () => {
    const nextPipeline = middlewarePipeline({ context, middleware, index: index + 1 })

    nextMiddleware({ ...context, next: nextPipeline })
  }
}
